<template>
	<div class="no-results">
		<Icon
			:icon-name="icon"
			size="xxl"
		/>
		<p class="no-results--title">
			{{ title }}
		</p>
		<p
			v-if="description"
			class="no-results--description"
		>
			{{ description }}
		</p>
	</div>
</template>

<script>
export default {
	name:  'NoResults',
	props: {
		title: {
			type:     String,
			required: true,
		},
		description: {
			type:    String,
			default: null,
		},
		icon: {
			type:    String,
			default: 'search',
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.no-results {
	padding: 124px 24px 24px 24px;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	align-items: center;
	white-space: normal;

	.is-mobile & {
		margin-top: 52px;
	}

	p {
		text-align: center;
	}

	> * {
		margin-bottom: 16px;
	}

	&--title {
		@include text-md-2;
	}

	&--description {
		@include text-sm-2;
		color: var(--color-grey-300);
	}
}

</style>
